/** Its instance allows you to chain middlewares */
export class MiddlewareComposition {
    constructor(...mdws) {
        this.middlewares = [];
        this.middlewares = mdws;
    }
    /** Allow adding middleware after initialization */
    add(mdw) {
        this.middlewares.push(mdw);
    }
    /** Pass the parameters through the middlewares chain */
    apply(properties, element) {
        let prevIndex = -1;
        let finalProperties = {
            href: properties.href,
            target: properties.target,
        };
        const runner = (index) => {
            if (index <= prevIndex) {
                throw new Error('next() called multiple times');
            }
            prevIndex = index;
            const middleware = this.middlewares[index];
            if (middleware) {
                middleware(finalProperties, element || null, (modifiedProperties) => {
                    if (modifiedProperties) {
                        finalProperties = modifiedProperties;
                    }
                    return runner(index + 1);
                });
            }
        };
        runner(0);
        return finalProperties;
    }
    /**
     * Pass a link through the middlewares chain. This usage is likely to be used when you do not deal with the HTML DOM, for example when you redirect a user within a framework without any anchor tag (`<a ...></a>`)
     *
     * Note: if any of the middleware is trying to deal with the anchor element, it will be ignored
     */
    applyToLink(href) {
        return this.apply({
            href,
            target: '',
        }).href;
    }
}
//# sourceMappingURL=middleware.js.map